export default __webpack_public_path__ + "static/media/template9.c6413149.jpg";